import { Intent } from 'signup-constants/Intent';
import { getFlowKey } from '../routing/getFlowKey';
import { getIntentKey } from '../routing/getIntentKey';
import { getIsMobile } from '../utils/deviceUtils';
import { Step } from '../views/Step';
import { FlowConfigRecord } from './FlowConfig';
import { NextStepManager } from '../flow-management/NextStepManager';

const getPostAccountCreationSteps = flowConfig => {
  let postAccountCreationSteps = flowConfig.steps.postAccountCreation || [];
  const intentKey = getIntentKey();

  if (flowConfig.shouldAddHubInterestStep()) {
    postAccountCreationSteps = postAccountCreationSteps.concat([Step.HubInterest]);
  }

  if (flowConfig.showMobileAppPrompt && getIsMobile() && intentKey !== Intent.campaignAssistant) {
    postAccountCreationSteps = postAccountCreationSteps.concat([Step.MobileAppPrompt]);
  }

  return postAccountCreationSteps;
};

const getPostVerificationSteps = flowConfig => {
  let postVerificationSteps = flowConfig.steps.postVerification || [];

  if (flowConfig.shouldUseManagementLevel()) {
    postVerificationSteps = NextStepManager.replaceStep(Step.JobRole, Step.ManagementLevel)(postVerificationSteps);
  }

  return postVerificationSteps;
};

export const getFlowConfig = () => {
  const flowKey = getFlowKey();
  const flowConfig = FlowConfigRecord[flowKey];

  if (!flowConfig) {
    throw new Error(`Invalid flow with key ${flowKey}.`);
  }

  return flowConfig;
};
export const getFlowSteps = () => {
  const flowConfig = getFlowConfig();
  const {
    preVerification,
    postExistingAccountSelection
  } = flowConfig.steps;
  return {
    preVerification,
    postVerification: getPostVerificationSteps(flowConfig),
    postExistingAccountSelection,
    postAccountCreation: getPostAccountCreationSteps(flowConfig)
  };
};